import { reatomAsync } from "@reatom/async";
import { CounterCreateDto } from "definitions/counter-api";
import { API } from "src/api";
import { getCountersRequest } from "src/pages/AdminUserPage/store/fetchers/getCountersRequest.ts";

export const upsertCountersRequest = reatomAsync(
  async (_, counterCreateDto: CounterCreateDto) => {
    return API.counterApi
      .counterControllerUpsertCounterAdmin(counterCreateDto)
      .then((response) => response.data);
  },
  {
    name: "upsertCountersRequest",
    onFulfill: (ctx, { userId }) => {
      getCountersRequest(ctx, { userId });
    },
  },
);
